// The fixed color palette (and the LIKERT rating scales built from it)
// shared by the engagement heatmap (LikertHeatmap) and the custom survey
// report charts (reportChartUtils). Kept in its own leaf module - no
// imports of its own - so reportChartUtils can use these colors without
// depending on LikertHeatmap.tsx, which would otherwise create a circular
// import (LikertHeatmap -> HorizontalBar -> reportChartUtils ->
// LikertHeatmap).
export const TEXT_COLOR = '#12263f';
export const WHITE = '#ffffff';
export const RED_DARK = '#e63757';
export const RED_LIGHT = '#fb999d';
export const GREEN_DARK = '#00d97e';
export const GREEN_LIGHT = '#9aecb7';
export const GRAY_LIGHT = '#EDEDED';
export const GRAY_DARK = '#888888';
export const YELLOW_DARK = '#FCC142';
export const YELLOW_LIGHT = '#F3D78C';
export const BLUE_DARK = '#89B0D1';
export const BLUE_LIGHT = '#B7C6D8';

// Same "off" gray used by CompletionDoughnutChart/PercentageCircleChart for
// the unfilled remainder of their rings - keep the "no response" slice
// visually consistent with that existing convention.
export const NO_RESPONSE_COLOR = '#EDF2F9';

export interface RatingScaleItem {
  value: number;
  text: string;
  color: string;
}

export const LIKERT_SCALE: RatingScaleItem[] = [
  {
    value: 5,
    text: '5. Strongly agree',
    color: GREEN_DARK,
  },
  {
    value: 4,
    text: '4. Agree',
    color: GREEN_LIGHT,
  },
  {
    value: 3,
    text: '3. Neutral',
    color: GRAY_LIGHT,
  },
  {
    value: 2,
    text: '2. Disagree',
    color: RED_LIGHT,
  },
  {
    value: 1,
    text: '1. Strongly disagree',
    color: RED_DARK,
  },
];

export const LIKERT_SCALE_ALTERNATE: RatingScaleItem[] = [
  {
    value: 5,
    text: '5. Strongly agree',
    color: BLUE_DARK,
  },
  {
    value: 4,
    text: '4. Agree',
    color: BLUE_LIGHT,
  },
  {
    value: 3,
    text: '3. Neutral',
    color: GRAY_LIGHT,
  },
  {
    value: 2,
    text: '2. Disagree',
    color: YELLOW_LIGHT,
  },
  {
    value: 1,
    text: '1. Strongly disagree',
    color: YELLOW_DARK,
  },
];
